<template>
  <footer class="mt-auto bg-morado-oscuro text-white source-sans">
    <b-container>
      <b-row>
        <b-col
          cols="12"
          order="1"
          lg="8"
          order-lg="0"
          class="small pt-3 text-center text-lg-left"
        >
          <div>Ministerio de Educación de Chile</div>
          <a
            href="https://www.gob.cl"
            target="_blank"
            class="d-block font-weight-bold text-white"
            >Gobierno de Chile</a
          >
          <div>Av. Libertador Bernardo O'Higgins 1371.</div>
          <div>Versión {{ version }}</div>
        </b-col>

        <b-container class="col-12 col-lg-4 order-0 order-lg-1 pt-2 text-right">
          <b-col class="pt-3 text-center">
            Consultas al siguiente teléfono
          </b-col>
          <b-col class="text-center">
            <FontAwesomeIcon
              icon="phone"
              class="fa-2x mt-2 d-none d-lg-inline-block"
            />
            <span class="h2 d-none d-lg-inline-block ml-2 font-weight-bold"
              >600 600 2626</span
            >
            <FontAwesomeIcon icon="phone" class="d-inline-block d-lg-none h5" />
            <a href="tel:6006002626" style="color: white;">
              <span class="h4 d-inline-block d-lg-none ml-1 font-weight-bold"
                >600 600 2626</span
              >
            </a>
          </b-col>
        </b-container>
      </b-row>
      <b-col cols="12" class="mt-4 mt-lg-2 p-0 text-center text-lg-left">
        <img
          src="https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/logofooter.png"
          width="160"
          height="15"
          alt=""
        />
      </b-col>
    </b-container>
  </footer>
</template>
<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faPhone);
export default {
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      version: VERSION
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/wrapper/Footer.vue